/**
 * Heat Loss Calculator
 * ===
 * Input View
 * 
 * Extends Backbone View.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */
'use strict';

import _ from 'underscore';
import Backbone from 'backbone';

import { HLC_Configs } from './../HeatLossCalculator.Configs.js';
import { HLC_Utils } from './../HeatLossCalculator.Utils.js';

/**
 * Input View
 *
 */
export var InputView = Backbone.View.extend({
    
    events: {
        'click button' : 'onButtonClick',
        'change input' : 'validateInput'
    },
    
    tagName: 'section',
    className: 'hlc-section hlc-input-pane is-inactive',
    
    template: undefined,
    buttons: undefined,
    
    initialize: function(options) {
        
        this.template = _.template(options.template);
        
        this.errors = [];
        this.buttons = options.buttons || [];
        
        this.$el.data('step', options.step_index);
        
        return this;
    },
    
    onButtonClick: function(e) {
        
        if ($(e.currentTarget).attr('name') == 'continue') {
            // Do nothing
        } else {
            this.$el.find('button').removeClass('is-selected');
            $(e.currentTarget).addClass('is-selected');
        }
        
    },
    
    validateInput: function(e) {
        
        var property, value;
        
        property = $(e.currentTarget).attr('name');
        value = $(e.currentTarget).val();
        
        switch (true) {
            
            case $(e.currentTarget).attr('min') !== undefined && value < Number($(e.currentTarget).attr('min')) :
            case $(e.currentTarget).attr('max') !== undefined && value > Number($(e.currentTarget).attr('max')) :
            case _.isEmpty(value) :
            case _.isNaN(Number(value)) && $(e.currentTarget).attr('type') != 'radio' :
            case Number(value) <= 0 :
                $(e.currentTarget).removeClass('is-valid').addClass('has-error');
                break;
                
            default :
                $(e.currentTarget).removeClass('has-error').addClass('is-valid');
        }
        
    },
    
    isComplete: function() {
        
        var button_count, exemptions, selections, errors = [];
        
        this.$el.find('button.has-error').removeClass('has-error');
        
        // console.log('Buttons length ' + this.$el.find('button').length);
        // console.log('Selected buttons length ' + this.$el.find('button.selected').length);
        // console.log('Input error length ' + this.$el.find('input.error').length);
        // console.log('Input not valid/exempt ' + this.$el.find('input').not('.valid, .exempt').length);
        
        button_count = this.$el.find('button').length;
        exemptions = this.$el.find('button.is-exempt').length;
        selections = this.$el.find('button.is-selected').length;
        
        if ( selections == 0 && button_count > exemptions ) {
            this.$el.find('button').not('.is-selected, .is-exempt').addClass('has-error');
            errors.push('A button option must be selected');
        }
        
        if (this.$el.find('input.has-error').length) {
            errors.push('There are one or more input fields with errors');
        }
        
        if (this.$el.find('input').not('.is-valid, .is-exempt').length) {
            this.$el.find('input').not('.is-valid, .is-exempt').addClass('has-error');
            errors.push('There are one or more fields that require valid input');
        }
        
        if (errors.length) {
            console.log(errors);
        }
        
        return errors.length ? false : true;
    },
    
    activate: function() {
        
        this.$el.find('.hlc-section__input').slideDown({
            start: function () {
                $(this).css({
                    display: 'flex'
                })
            }
        });
        this.$el.removeClass('is-inactive').addClass('is-active');
    },
    
    deactivate: function() {
        this.$el.removeClass('is-active');
    },
    
    render: function() {
        
        var data, compiled;
        
        data = this.model.toJSON();
        
        data.delta_t = this.model.deltaT();
        data.configs = HLC_Configs;
        
        this.$el.html(this.template(data)).attr('data-step', this.$el.data('step'));
        
        return this;
    }
    
});
